module.exports = __webpack_public_path__ + "img/Group 788.5e05f080.svg";